import React from 'react';
import ConfirmationDialog from '../../ConfirmationDialog';

const Body = ({ selectedTasks }) => {
 return (
    <div className="sign-dialog">
        {selectedTasks.map(task =>
            <div  key={task.taskId} className="sign-dialog--task">
                <div>TASK:</div>
                <div>{task.description}</div>
            </div>
        )}
    </div>
  );
}

const TaskNaDialog = ({ tasks, role, onClose, onAccept, ...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { onClose }
        cancelButton={{
            action: onClose,
            label: 'NO, CANCEL'
        }}
        acceptButton={{
            action: onAccept,
            label: 'YES, MARK N/A'
        }}
        header="Are you sure you want to mark the following tasks as not applicable?"
        body={<Body selectedTasks={tasks} />}
    />;

export default TaskNaDialog;